import {
    ABTesting,
    Analytics,
    DataWarehouse,
    EventPipelines,
    FeatureFlags,
    SelfHosting,
    SessionRecording,
} from './Icons'

export const slideButtons = [
    {
        title: 'Product analytics',
        Icon: Analytics,
    },
    {
        title: 'Session recording',
        Icon: SessionRecording,
    },
    {
        title: 'Feature flags',
        Icon: FeatureFlags,
    },
    {
        title: 'A/B testing',
        Icon: ABTesting,
    },
    {
        title: 'Event pipelines',
        Icon: EventPipelines,
    },
    {
        title: 'Data warehouse',
        Icon: DataWarehouse,
    },
    {
        title: 'Self-hosting',
        Icon: SelfHosting,
    },
]
